const CURRENCY_DEFAULT_PRECISION: Record<string, number> = {
  USDT: 4,
  ZAR: 2,
};

export const getCurrencyDefaultPrecision = (currencyId: string): number =>
  CURRENCY_DEFAULT_PRECISION[currencyId] ?? 2;
